import { cn } from "@/lib/utils";

type StatusVariant = "for-sale" | "sold" | "featured" | "new" | "investment" | "under-contract";

interface StatusBadgeProps {
  variant: StatusVariant;
  className?: string;
}

const variantStyles: Record<StatusVariant, string> = {
  "for-sale": "bg-accent text-accent-foreground",
  "sold": "bg-destructive text-destructive-foreground",
  "featured": "bg-secondary on-dark text-foreground",
  "new": "bg-foreground text-background",
  "investment": "bg-accent/20 text-accent border border-accent/40",
  "under-contract": "bg-muted-foreground/20 text-foreground border border-border",
};

const variantLabels: Record<StatusVariant, string> = {
  "for-sale": "For Sale",
  "sold": "Sold",
  "featured": "Featured",
  "new": "New Listing",
  "investment": "Investment",
  "under-contract": "Under Contract",
};

const StatusBadge = ({ variant, className }: StatusBadgeProps) => (
  <span
    className={cn(
      "inline-flex items-center font-body text-[10px] uppercase tracking-[0.2em] px-3 py-1.5",
      variantStyles[variant],
      className
    )}
  >
    {variantLabels[variant]}
  </span>
);

export default StatusBadge;
